var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var PlaylistEvent = /* @__PURE__ */ ((PlaylistEvent2) => {
  PlaylistEvent2["PLAYLIST_ADVANCED"] = "playlistadvanced";
  PlaylistEvent2["PLAYLIST_CHANGED"] = "playlistchanged";
  PlaylistEvent2["PLAYLIST_COMPLETE"] = "playlistcomplete";
  PlaylistEvent2["PLAYLIST_OUT_OF_RANGE"] = "playlistoutofrange";
  PlaylistEvent2["PLAYLIST_CLEARED"] = "playlistcleared";
  PlaylistEvent2["PLAYLIST_ERROR"] = "playlist_error";
  return PlaylistEvent2;
})(PlaylistEvent || {});
const PLAYLIST = "playlist";
function createPlaylistPlugin(services, options) {
  return new AviaPlaylistPlugin(services, options);
}
function playlist(options = {}) {
  return {
    id: PLAYLIST,
    factory: createPlaylistPlugin,
    options
  };
}
class AviaPlaylistPlugin {
  constructor(services, options) {
    this._list = [];
    this.advancing = false;
    this.completed = false;
    this.services = services;
    this.options = options;
    this.logger = services.logger;
    this.onResourceEnd = this.onResourceEnd.bind(this);
    this.listenToPlayer(true);
    this.logger.info(`${PLAYLIST} created.`);
  }
  getId() {
    return PLAYLIST;
  }
  destroy() {
    this.listenToPlayer(false);
    this._list = null;
  }
  get list() {
    return this._list.map((r) => {
      return __spreadValues({}, r);
    });
  }
  get length() {
    var _a;
    return ((_a = this._list) == null ? void 0 : _a.length) || 0;
  }
  get currentIndex() {
    return this._currentIndex;
  }
  set currentIndex(index) {
    if (index < 0 || index >= this._list.length) {
      return;
    }
    const cur = Math.max(this._currentIndex, 0);
    this.advance(index - cur);
  }
  get currentResource() {
    var _a;
    const i = (_a = this._list) == null ? void 0 : _a[this._currentIndex];
    return i ? this.avia.Util.merge({}, i) : null;
  }
  get nextResource() {
    const r = this.find(this._currentIndex + 1);
    return r ? this.avia.Util.merge({}, r) : null;
  }
  get prevResource() {
    const r = this.find(this._currentIndex - 1);
    return r ? this.avia.Util.merge({}, r) : null;
  }
  next() {
    return __async(this, null, function* () {
      return this.advance(1);
    });
  }
  prev() {
    return __async(this, null, function* () {
      return this.advance(-1);
    });
  }
  clear() {
    this._list = [];
    this._currentIndex = -1;
    this.emit(PlaylistEvent.PLAYLIST_CLEARED);
  }
  start(idx = 0) {
    this._currentIndex = !isNaN(idx) ? idx - 1 : -1;
    return this.advance();
  }
  addResources(resources, index = null) {
    if (this.avia.Util.isEmpty(resources)) {
      const message = "addResources(): received 'null'; a resource or resource array must be provided.";
      this.logger.error(message);
      this.emit(PlaylistEvent.PLAYLIST_ERROR, { message });
      return;
    }
    const a = !Array.isArray(resources) ? [resources] : resources;
    a.forEach((v, i) => {
      const r = this.avia.createResourceConfig(v);
      index != null ? this._list.splice(index + i, 0, r) : this._list.push(r);
    });
  }
  removeResourceAtIndex(idx) {
    return __async(this, null, function* () {
      return new Promise((resolve) => {
        const itm = this._list.splice(idx, 1);
        if (idx === this.currentIndex) {
          this.player.stop().then(() => {
            resolve(itm == null ? void 0 : itm[0]);
          });
        } else if (idx >= 0 && idx < this._list.length) {
          resolve(itm == null ? void 0 : itm[0]);
        } else {
          resolve(null);
        }
      });
    });
  }
  onResourceEnd(event) {
    if (this.advancing || event.detail.interrupted) {
      return;
    }
    this.next();
  }
  advance(inc = 1) {
    return __async(this, null, function* () {
      var _a, _b;
      const currentIndex = this._currentIndex + inc;
      const resource = this.find(currentIndex);
      let event;
      if (resource) {
        this.advancing = true;
        this.completed = false;
        return (_a = this.player) == null ? void 0 : _a.attachResource(resource).then((result) => {
          this.emit(PlaylistEvent.PLAYLIST_ADVANCED, { currentIndex });
          this._currentIndex = currentIndex;
          this.advancing = false;
          return result;
        });
      } else {
        const overRange = currentIndex >= ((_b = this._list) == null ? void 0 : _b.length);
        if (overRange || currentIndex < 0) {
          if (overRange && !this.completed) {
            this.completed = true;
            event = PlaylistEvent.PLAYLIST_COMPLETE;
          } else {
            event = PlaylistEvent.PLAYLIST_OUT_OF_RANGE;
          }
        }
      }
      if (event) {
        this.logger.info(`Playlist status: ${event}`);
        this.emit(event);
      }
      return Promise.resolve(null);
    });
  }
  find(idx) {
    return idx >= 0 && idx < this._list.length && this._list[idx] || null;
  }
  get avia() {
    return this.services.avia;
  }
  get player() {
    return this.services.player;
  }
  emit(type, data) {
    this.services.event.dispatchPluginEvent({
      id: PLAYLIST,
      type,
      data
    });
  }
  listenToPlayer(flag) {
    this.player[flag ? "on" : "off"](this.avia.PlayerEvent.RESOURCE_END, this.onResourceEnd);
  }
}
const ID = PLAYLIST;
const createPlugin = createPlaylistPlugin;
const plugin = playlist;
export {
  AviaPlaylistPlugin,
  ID,
  PLAYLIST,
  PlaylistEvent,
  createPlaylistPlugin,
  createPlugin,
  playlist,
  plugin
};
//# sourceMappingURL=avia.playlist.esm.js.map
